function initFaqSection(section) {
  if (!section) return;

  const accordions = section.querySelectorAll(".m-collapsible");

  accordions.forEach((accordion) => {
    if (accordion.dataset.faqInitialized === "true") return;

    const summary = accordion.querySelector("summary");
    const content = accordion.querySelector(".m-collapsible--content");

    if (!summary || !content) return;

    accordion.dataset.faqInitialized = "true";

    if (accordion.hasAttribute("open")) {
      content.style.height = "auto";
      content.style.opacity = "1";
    }

    summary.addEventListener("click", (event) => {
      event.preventDefault();

      const isOpen = accordion.hasAttribute("open");

      if (isOpen) {
        content.style.height = content.scrollHeight + "px";
        content.offsetHeight;

        requestAnimationFrame(() => {
          content.style.height = "0px";
          content.style.opacity = "0";
        });

        const handleClose = (transitionEvent) => {
          if (transitionEvent.propertyName !== "height") return;
          accordion.removeAttribute("open");
          content.style.height = "0px";
          content.removeEventListener("transitionend", handleClose);
        };

        content.addEventListener("transitionend", handleClose);
        return;
      }

      accordion.setAttribute("open", "");
      content.style.height = "0px";
      content.style.opacity = "0";
      content.offsetHeight;

      requestAnimationFrame(() => {
        content.style.height = content.scrollHeight + "px";
        content.style.opacity = "1";
      });

      const handleOpen = (transitionEvent) => {
        if (transitionEvent.propertyName !== "height") return;
        content.style.height = "auto";
        content.removeEventListener("transitionend", handleOpen);
      };

      content.addEventListener("transitionend", handleOpen);
    });
  });
}

function initFaqSections(root = document) {
  root
    .querySelectorAll('[data-section-type="page-faqs"]')
    .forEach(initFaqSection);
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", () => initFaqSections());
} else {
  initFaqSections();
}

document.addEventListener("shopify:section:load", (event) => {
  initFaqSections(event.target);
});
